module.exports = __webpack_public_path__ + "static/media/person_border_darkbleu.b6e3db0b.svg";